"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerContext = void 0;
const react_1 = require("react");
exports.CustomerContext = (0, react_1.createContext)({
    isLogged: false,
    isRecognized: false,
    customerId: undefined,
    customerInfo: undefined,
    handleLogout: () => {
        return null;
    },
});
